<template>
  <b-modal
    class="text-left"
    ref="orderModal"
    :title="$t('order.orderQuestion')"
    :hide-footer="loader"
  >
    <div class="loader" v-if="loader&&!ready"></div>
    <h5>{{ $t('order.projectSummary') }}:</h5>
    <div class="container">
      <div class="row">
        <div class="col">{{ $t('order.totalPrice') }}:</div>
        <div class="col">{{ formatPrice(bom.total) }}</div>
      </div>
      <div class="row">
        <div class="col">{{ $t('order.totalWeight') }}:</div>
        <div class="col">{{ formatWeight(bom.totalWeight) }}</div>
      </div>
      <div class="row">
        <div class="col">{{ $t('order.amountOfConfigurations') }}:</div>
        <div class="col">{{ bom.entries.length }}</div>
      </div>
    </div>
    <div
      class="success"
      v-if="ready"
    >Herzlichen Glückwunsch! Das Projekt wurde erfolgreich bestellt.</div>

    <b-alert v-if="invalidConfiguration" class="mt-4" variant="danger" show>
      {{ $t('order.errorInConfiguration', [invalidConfiguration.configurationName]) }}
    </b-alert>


    <template slot="modal-footer">
      <b-button @click="$refs.orderModal.hide()">{{$t('cancel')}}</b-button>
      <b-button
        autofocus
        class="send-button"
        @click="confirmButtonClicked"
        :disabled="loadingValidation || invalidConfiguration != null"
      >{{$t('order.orderConfirm')}}</b-button>
    </template>
  </b-modal>
</template>

<script>
import formatNumbers from "../formatNumbers"

export default {
  mixins: [formatNumbers],
  data() {
    return {
      loader: false,
      ready: false
    };
  },
  computed: {
    bom() {
      return this.$store.state.projects.projectBom || [];
    },
    invalidConfiguration() {
      if (this.$store.state.projects.projectValidation == null) return null;
      if (this.$store.state.projects.projectValidation.status == "ok") return null;
      const result = this.$store.state.projects.projectValidation

      return this.$store.state.configurations.configurationAmounts[result.configurationIndex].configuration
    },
    loadingValidation() {
      return this.$store.state.projects.loadingProjectValidation;
    }
  },
  methods: {
    show() {
      this.$refs.orderModal.show();
      this.$store.dispatch("projects/validate");
    },

    async confirmButtonClicked() {
      this.loader = true;

      await this.$store.dispatch("projects/orderProject");

      setTimeout(() => {
        this.ready = true;
      }, 500);

      this.$refs.orderModal.hide();
    }
  }
};
</script>

<style scoped>
.send-button {
  color: #fff;
  background-color: #00a0e4;
  border-color: #00a0e4;
}
.loader {
  margin: auto;
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid #3498db; /* Blue */
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
